var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":`0 0 ${_vm.viewBox} ${_vm.viewBox}`,"height":_vm.size,"width":_vm.size}},[_c('path',{attrs:{"fill":_vm.color !== 'primary' ? _vm.color : _vm.$vuetify.theme.themes.light.primary,"d":_vm.iconCode}})])
}
var staticRenderFns = []

export { render, staticRenderFns }